import { render, staticRenderFns } from "./AddStudentDiscountAmount.vue?vue&type=template&id=69f6c3a2&scoped=true&"
import script from "./AddStudentDiscountAmount.vue?vue&type=script&lang=js&"
export * from "./AddStudentDiscountAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f6c3a2",
  null
  
)

export default component.exports